
import React from "react";
import PropTypes from "prop-types";

export default function CardButton({
  statSubtitle,
  statTitle,
  statArrow,
  statPercent,
  statPercentColor,
  statDescripiron,
  statIconName,
  statIconColor,
  create
}) {
  return (
    <>
      {/* <div className="relative flex min-w-0 mb-6 break-words bg-white rounded-lg shadow-lg xl:mb-0 " style={{ width: "150px" }}> */}
        {/* <div className="flex-auto p-2 " style={{alignSelf:"center"}}> */}
        {/* <div className="flex flex-wrap " > */}
        {/* <a className="relative flex-1 flex-grow " > */}
        <button
          className="p-4 font-bold text-white uppercase bg-indigo-500 rounded-lg outline-none text-md active:bg-indigo-600 focus:outline-none" style={{ width: "150px" }}
          type="button"
          // style={{paddingLeft: "5rem", paddingRight: "5rem" ,maxWidth:"100%"}}
          onClick={() => window.location.href = create}
        >
          Create
        </button>
        {/* </a> */}
        {/* </div> */}
        {/* </div> */}
      {/* </div> */}
    </>
  );
}

CardButton.defaultProps = {
  statSubtitle: "Traffic",
  statTitle: "350,897",
  statArrow: "up",
  statPercent: "3.48",
  statPercentColor: "text-emerald-500",
  statDescripiron: "Since last month",
  statIconName: "far fa-chart-bar",
  statIconColor: "bg-red-500",
};

CardButton.propTypes = {
  statSubtitle: PropTypes.string,
  statTitle: PropTypes.string,
  statArrow: PropTypes.oneOf(["up", "down"]),
  statPercent: PropTypes.string,
  // can be any of the text color utilities
  // from tailwindcss
  statPercentColor: PropTypes.string,
  statDescripiron: PropTypes.string,
  statIconName: PropTypes.string,
  // can be any of the background color utilities
  // from tailwindcss
  statIconColor: PropTypes.string,
};
